/**
 * Haven's instantiation of the translation-key kit in `@thalamos/common` — see
 * `translationKit.ts` there for the mechanism and why keys collapse to a
 * branded string. A mistyped key is a compile error at the `tk()` call rather
 * than a raw key rendered at a user.
 */
import { z } from "zod";

import type { StrictNestedKeys } from "@thalamos/common";

import type common from "./en/common.js";

/** A strongly-typed union of all valid translation keys in the base locale. */
export type TranslationKeyUnbranded = StrictNestedKeys<typeof common>;

// Exists solely to mint the branded type below.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const TranslationKeySchema = z
  .string()
  .brand<"haven-frontend:TranslationKey">();

/** A simple branded type to represent a valid translation key. */
export type TranslationKey = z.infer<typeof TranslationKeySchema>;

/**
 * Convert a strongly-typed translation key into a less demanding branded type.
 * The collapse is what keeps the compiler alive on a key union with thousands
 * of members; the full rationale lives on the translation kit's module
 * docblock in `@thalamos/common`.
 */
export const tk = (key: TranslationKeyUnbranded): TranslationKey => {
  return key as TranslationKey;
};
